module.exports = __webpack_public_path__ + "img/Unidad12-3.59950367.png";